import _ from 'lodash';
import { safeToBig } from 'shared/helpers/utils_math';
import { getProductVolumeInFluidOunces } from 'shared/helpers/products';
import { getTypeLimits, getLimitMessage, getEffectiveSubcategories, isPurchaseLimitTypeOverrideEnforced } from '../utils';
export function isLiquidEdible(product, limits) {
    var useMultiSubcategories = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, purchaseLimitTypeOverrideIsEnforced = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
    // A finite routed purchaseLimitType is exclusive. If the jurisdiction does not cap that purchaseLimitType,
    // retain the physical-form limit so customer routing cannot create an unlimited legal category.
    if (product.purchaseLimitTypeOverride && purchaseLimitTypeOverrideIsEnforced) return false;
    var type = product.type;
    var subcategories = getEffectiveSubcategories(product, useMultiSubcategories);
    var liquidEdibleTypes = limits.liquidEdibleTypes;
    return _.intersection(liquidEdibleTypes === null || liquidEdibleTypes === void 0 ? void 0 : liquidEdibleTypes.subcategories, subcategories).length > 0 || _.includes(liquidEdibleTypes === null || liquidEdibleTypes === void 0 ? void 0 : liquidEdibleTypes.categories, type);
}
export function checkLiquidEdibleVolume(cart) {
    var getFlowerEquivalent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {
        return 0;
    };
    var state = cart.state;
    var liquidEdibleVolumeLimitInOunces = getTypeLimits(cart).liquidEdibleVolumeLimitInOunces;
    var totalVolumeInOunces = getTotalVolumeInOuncesForCart(cart, getFlowerEquivalent);
    var message = getLimitMessage('liquid edibles', liquidEdibleVolumeLimitInOunces, state, 'oz');
    return totalVolumeInOunces > liquidEdibleVolumeLimitInOunces ? {
        total: totalVolumeInOunces,
        message: message,
        withinLimits: false
    } : {
        withinLimits: true
    };
}
export function getTotalVolumeInOuncesForCart(param) {
    var orders = param.orders, limits = param.limits, state = param.state, medical = param.medical, useMultiSubcategories = param.useMultiSubcategories, getFlowerEquivalent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {
        return 0;
    };
    var enforcementContext = {
        limits: limits,
        medical: medical,
        useMultiSubcategories: useMultiSubcategories
    };
    return Number(_.reduce(orders, function(previous, order) {
        var product = order.product, quantity = order.quantity;
        if (!isLiquidEdible(product, limits, useMultiSubcategories, isPurchaseLimitTypeOverrideEnforced(product, enforcementContext))) {
            return previous;
        }
        var volume = getProductVolumeInFluidOunces(product);
        var totalVolumeForOrder = safeToBig(volume).times(quantity).round(5);
        var isBritishColumbiaDispensary = state === 'BC';
        var flowerEquivalent = isBritishColumbiaDispensary ? getFlowerEquivalent(order, medical, limits, useMultiSubcategories) : 0;
        var useEquivalent = !!flowerEquivalent;
        return safeToBig(previous).plus(useEquivalent ? flowerEquivalent : totalVolumeForOrder);
    }, 0.0));
}
